export function nl2br(str) {
    return str && str.replace(/\r?\n/g, '<br/>');
}
